import appsList from '../../../user/header/Apps/Popover/list.json';

import { timeoutSignal } from '../../../../../shared';
import {
  getStorageItems,
  setStorageItems,
} from '../../../../../shared/chromeApi';
import { ENGINES } from '../../utils';
import {
  AdMarketplaceData,
  AdMarketplaceLongTailData,
  BuildingSuggestion,
  HistoryPage,
  SearchTag,
  Zeropark,
} from '../types';

import { PopularWebsite } from '../types';
import { withHttp } from '../utils';

const inMemory = {};

export const requestOrganicSuggestions = async (
  q: string,
  engine: string,
  searchTag?: SearchTag
): Promise<string[] | BuildingSuggestion[]> => {
  if (!q) return [];

  try {
    // const isWeb = process.env.NODE_ENV === 'production' &&
    //   process.env.APP_PLATFORM === 'web';
    const isWeb = process.env.APP_PLATFORM === 'web';
    const { suggestionsUrl, query, formatter } = isWeb
      ? ENGINES.oh
      : ENGINES[engine];

    const url = `${suggestionsUrl}?${new URLSearchParams(query(q, searchTag))}`;
    if (!inMemory[url]) {
      const response = await fetch(url);
      try {
        if (response.ok) {
          inMemory[url] = await formatter(response);
        }
      } catch (err) {
        console.error('formatter', err);
      }
    }

    return inMemory[url] || [];
  } catch (err) {
    console.error('requestOrganicSuggestions', err);
    return [];
  }
};

export const requestAdmarketplaceLongTailSuggestions = async (
  qt: string
): Promise<AdMarketplaceLongTailData> => {
  const defaultResult = {
    status: { code: null, text: null },
    adlistings: { listing: [] },
    count: '0',
    response: null,
  };

  if (!qt) return defaultResult;

  try {
    const ip = localStorage.getItem('ip');
    // '96.41.207.187'
    const qs = new URLSearchParams({
      qt,
      partner: 'oceanhero_extn_search',
      sub1: 'oceanhero',
      v: '7',
      ...(ip && { ip }),
      ua: navigator.userAgent,
      rfr: 'https://chrome.google.com/webstore/detail/oceanhero-save-the-oceans/cdbccfkcpkmimlajcjpodelocoeifjhp',
      results: '2',
      out: 'json',
    });

    const url = `https://${qs.get('partner')}.ampfeed.com/xmlamp/feed?${qs}`;
    if (!inMemory[url]) {
      const response = await fetch(url, { signal: timeoutSignal(2000) });
      inMemory[url] = response.status === 200 ? await response.json() : null;
    }

    return inMemory[url];
  } catch (err) {
    console.error('requestAdSuggestions', err);
    return defaultResult;
  }
};

/*
export const requestLiteralcoSuggestions = async (qt: string): Promise<Suggestion[]> => {
  if (!qt) return [];

  try {
    const qs = new URLSearchParams({ q: qt, sourceID: 'Default', format: 'searchList' });
    const url = `https://rt53.literallysafe.com/getSuggestions?${qs}`;
    if (!inMemory[url]) {
      const response = await fetch(url, { signal: timeoutSignal(1000) });
      inMemory[url] = response.status === 200 ? (await response.json()) : null;
    }

    return inMemory[url];
  } catch (err) {
    console.error('requestAdSuggestions', err);
    return [];
  }
};
 */

export const requestAdSuggestions = async (
  qt: string
): Promise<AdMarketplaceData> => {
  const adSuggestionsDefault = {
    original_qt: qt,
    paid_suggestions: [],
    organic_suggestions: [],
  };

  if (!qt) return adSuggestionsDefault;

  try {
    let ip = localStorage.getItem('ip');

    if (!ip) {
      const response = await fetch('https://api.ipify.org?format=json');
      const { ip: newIp } = await response.json();
      localStorage.setItem('ip', newIp);
      ip = newIp;
    }

    // '96.41.207.187'
    const qs = new URLSearchParams({
      qt,
      partner: 'oceanhero_extn_cps',
      sub1: 'oceanhero',
      v: '1.4',
      ...(ip && { ip }),
    });

    const url = `https://${qs.get(
      'partner'
    )}.cps.ampfeed.com/suggestions?${qs}`;
    if (!inMemory[url]) {
      const response = await fetch(url, { signal: timeoutSignal(1000) });
      inMemory[url] = response.status === 200 ? await response.json() : null;
    }

    return inMemory[url];
  } catch (err) {
    console.error('requestAdSuggestions', err);
    return adSuggestionsDefault;
  }
};

export const findTakeMerchants = async (q: string) => {
  const { countryCode = 'US' } = (await getStorageItems([
    'countryCode',
  ])) as any;

  const merchants = await fetch(
    process.env.APP_URL + '/api/suggest/take?country=' + countryCode + '&q=' + q
  ).then((res) => res.json());

  return merchants || [];
};

export const findCustomMerchants = async (q: string) => {
  const { countryCode = 'US' } = (await getStorageItems([
    'countryCode',
  ])) as any;

  const merchants = await fetch(
    process.env.APP_URL + '/api/suggest/custom?country=' + countryCode + '&q=' + q
  ).then((res) => res.json());

  return merchants || [];
};

export const findZeroParkMerchants = async (q: string) => {
  const { countryCode = 'US' } = (await getStorageItems([
    'countryCode',
  ])) as any;

  const merchants = await fetch(
    process.env.APP_URL +
    '/api/suggest/zeropark?country=' +
    countryCode +
    '&q=' +
    q
  )
    .then((res) => res.json())
    .catch((err) => {
      console.error('findZeroParkMerchants', err);
      return [];
    });

  return merchants.slice(0, 3) || [];
};

export const findAffinityMerchants = async (q: string) => {
  const { countryCode = 'US' } = (await getStorageItems([
    'countryCode',
  ])) as any;

  const merchants = await fetch(
    process.env.APP_URL +
    '/api/suggest/affinity?country=' +
    countryCode +
    '&q=' +
    q
  )
    .then((res) => res.json())
    .catch((err) => {
      console.error('findAffinityMerchants', err);
      return [];
    });

  return merchants || [];
};

export const findAdMarketplaceMerchants = async (q: string) => {
  const merchants = await fetch(
    process.env.APP_URL +
    '/api/suggest/adMarketplace?&q=' + q
  )
    .then((res) => res.json())
    .catch((err) => {
      console.error('findAdMarketplaceMerchants', err);
      return [];
    });

  return merchants || [];
};

export const findOrganicResults = async (q: string) => {
  const results = await fetch(
    process.env.APP_URL +
    '/api/suggest/organic?q=' + q
  )
    .then((res) => res.json())
    .catch((err) => {
      console.error('findOrganic', err);
      return [];
    });

  return results || [];
};

export const requestPopularWebsites = (): Promise<PopularWebsite[]> =>
  import('../data/popularWebsites.json').then((result) => [
    ...appsList.map(({ name, url }) => ({ url, term: name })),
    ...result.default.map(({ term, url }) => ({ url: withHttp(url), term })),
  ]);

export const requestHistory = async (): Promise<HistoryPage[]> => {
  const { browserHistory } = (await getStorageItems(['browserHistory'])) as any;
  return browserHistory;
};

export const removeHistorySuggestion = async (
  url: string
): Promise<HistoryPage[]> => {
  const current = await requestHistory();
  const browserHistory = current.filter((history) => history.url !== url);
  await setStorageItems({ browserHistory });
  return browserHistory;
};

export const requestZeropark = async (): Promise<Zeropark> => {
  const { zp } = await getStorageItems<{ zp: Zeropark }>(['zp']);
  if (!zp?.brands?.length) return null;

  return {
    ...zp,
    brands: zp.brands
      .map((brand) => ({
        ...brand,
        // @ts-ignore
        keywords: brand.keywords.split(','),
      }))
      .sort((a) => -a.eCpc),
  };
};

export const getLinkedTabs = async () => {
  const results = await fetch(
    process.env.APP_URL +
    '/api/linked-tabs')
    .then((res) => res.json())
    .catch((err) => {
      console.error('linkedTabs', err);
      return [];
    });

  return results || [];
}